import React from "react";
import { FieldsEditor } from "../editors";

/**
 * Profile → Fields tab. The mapping table: source column → iconik field (+ type) → per-field
 * strategy.
 */

export default function FieldsPanel({ id }: { id: string }) {
  return <FieldsEditor id={id} />;
}
